import { Command } from 'commander';
import { GenerateStepCommand } from './generateStepCommand';

export function StepCommand(): Command {
  const cmd = new Command('step');
  cmd.alias('st').description('Steps related commands.');

  cmd.addCommand(GenerateStepCommand());
  return cmd;
}
